import { supertypeClass, property, Remoteable, Persistable, amorphicStatic } from '@haventech/amorphic';
import { IsomorphicPersistent } from '@hit/amorphic-types';
import { Party } from '../customer/Party';
import { Person } from '../customer/Person';
import { AgentProfile, PrincipalType } from '../customer/AgentProfile';
import { Phone } from '../customer/Phone';

@supertypeClass({ toClient: true, toServer: true })
export class OpsProxy extends IsomorphicPersistent {
  @property({ rule: ['text', 'required'], comment: 'Serving proxy Id number' })
  proxyId: string;

  /* Personal info for the agent.*/
  @property({ getType: () => Party, comment: 'Personal info for the proxy' })
  party: Party;

  /**
   * @deprecated - Use groups instead
   */
  @property({ toServer: false, comment: 'The data.group from SAML this Proxy is part of' })
  group: string;

  // This will capture all groups the logged in user belongs to. The above group column is deprecated and
  // will be removed next sprint
  @property({
    toServer: false,
    type: Array,
    getType: () => String,
    comment:
      'The data.groups from SAML this Agent is part of. This is an array of strings like fim-coverpath-agent, fim-coverpath-help etc',
  })
  groups: string[];

  @property({ getType: () => AgentProfile })
  profile: AgentProfile;

  @property({ comment: 'true if the proxy logged in at least once' })
  hasEverLoggedIn: boolean;

  @property({ toServer: false, comment: 'Indicates the producerId mocked for local use' })
  mockedProducerId?: string = '';

  constructor() {
    super();
  }

  static new(proxyId: string) {
    return new OpsProxy().init(proxyId);
  }

  init(proxyId: string) {
    this.proxyId = proxyId;
    this.party = Person.new();
    this.profile = AgentProfile.new(this, PrincipalType.OpsProxy);
    return this;
  }

  get producerId(): string {
    return this.proxyId;
  }

  get person(): Person {
    return this.party as Person;
  }

  get phone(): Phone {
    return this.party.phone;
  }

  set phone(phone: Phone) {
    this.party.phone = phone;
  }

  get displayNameWithLastName(): string {
    return `${this.displayName} ${this.person.lastName}`.trim();
  }

  get displayName(): string {
    return (this.profile && this.profile.displayName) || this.person.firstName;
  }
}
